export default {"src":"/_next/static/media/arrow-up.8b50314b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};